import { SECTIONS } from '../sections/registry.ts';

export function Sidebar({ current }: { current: string }) {
  return (
    <nav className="sidebar" aria-label="Console sections">
      <p className="brand">Vendor console</p>
      <ul>
        {SECTIONS.map((section) => (
          <li key={section.id}>
            <a href={`#/${section.id}`} aria-current={section.id === current ? 'page' : undefined}>
              {section.title}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
